export default "__VITE_ASSET__ielUq2VI__"